export default __webpack_public_path__ + "static/media/logo-rounded.0c894d24.png";